<template>
  <div>
    <!-- <el-menu :default-active="active" mode="horizontal" @select="handleSelect" background-color="transparent" text-color="#2F2F2F"
           active-text-color="#fff">
    <template v-for="i in realMenuList">
      <el-menu-item v-if="i.name !== '|'" :key="i.name" :index="i.url">{{ i.name }}</el-menu-item>
      <el-menu-item v-else :key="i.url" >
        <svg xmlns="http://www.w3.org/2000/svg" width="2" height="16" viewBox="0 0 2 16" fill="none">
          <path d="M1 0V16" stroke="#A1A1A1" />
        </svg>
      </el-menu-item>
    </template>
  </el-menu> -->
    <ul class="el-menu--horizontal">
      <li v-for="i in realMenuList" :class="`el-menu-item ${$route.path.includes(i?.url) ? 'is-active':''}`" :key="i.name" @click="handleSelect(i.url)">{{ i.name }}</li>
    </ul>
  </div>
</template>

<script>
import { isProd, getDevMainpage } from '@/utils/common'
export default {
  props: ['hasToken', 'isPro'],
  data() {
    return {
      menuList: [
        {
          url: '/home',
          name: '首页',
        },
        {
          url: `/awards`,
          name: '赛事',
        },
        {
          url: '/wiki',
          name: '文档',
        },
        {
          url: '/learn',
          name: '视频学堂',
        },
        {
          url: `/forum/`,
          name: '社区',
        },
        // {
        //   url: this.goToDevelopPlat?.(),
        //   name: '开发者中心',
        // },
      ],
      active: '/learn',
    }
  },
  mounted(){
    console.log('this.$route',this.$route);
    
  },
  computed: {
    realMenuList() {
      // return this.hasToken
      //   ? this.menuList
      //   : [{ url: `${location.origin}/cp/awards/`, name: '赛事' }]
      return this.menuList
    },
  },

  methods: {
    handleSelect(key, keyPath) {
      if(key === this.$route?.path) return;
      if (key?.includes('http')) {
        window.open(key)
      } else {
        // this.$router.push(key)
        console.log('key', key)
        window.open(`#${key}`)
      }
    },

    goToDevelopPlat() {
      let devUrl = 'https://dev.minicreate.qq.com/'
      if (isProd()) {
        devUrl = `https://${getDevMainpage()}/`
      }
      return devUrl
    },

    activeMenu() {
      const route = this.$route
      console.log('route', route)
      const { path } = route
      let routePath
      routePath = path
      let routeArr = routePath.split('/')
      // console.log('routePath', routePath)
      this.active = `/${routeArr[1]}`
      console.log('routePath', routePath)
    },
  },
}
</script>

<style>
.el-menu--horizontal > .el-menu-item {
  color: #1D1D1D;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding: 0;
  margin-right: 35px;
  height: 35px;
  line-height: 35px;
  display: flex;
  align-items: center;
}
.el-menu--horizontal > .el-menu-item:last-of-type{
  margin-right: 0;
}
.el-menu--horizontal > .el-menu-item:hover {
  /* color: rgb(44, 121, 127) !important; */
  text-decoration: none;
  background: unset !important;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border: 0;
  background-image: url('../assets/img/navActiveBg.png');
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  border-bottom: 2px solid;
  border-image: url('../assets/img/navActiveBg.png') 11 round;
  /* pointer-events: none; */
}
.el-menu--horizontal > .el-menu-item.is-active:hover {
  background-image: url('../assets/img/navActiveBg.png') !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}
.el-menu.el-menu--horizontal {
  border-bottom: unset;
  display: flex;
  align-items: center;
}
</style>
